module.exports = __webpack_public_path__ + "static/media/PYT_FI.4eb12869.png";